import { motion } from 'framer-motion';

export default function RadioGroup({
  id,
  label,
  options,
  value,
  onChange,
  required = false,
  error = ''
}) {
  return (
    <div className="w-full">
      <label className="block text-lg font-semibold text-charcoal mb-4">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <div className="space-y-3">
        {options.map((option) => (
          <motion.label
            key={option.value}
            className={`flex items-center p-4 border-2 rounded-button cursor-pointer transition-all ${
              value === option.value
                ? 'border-renuvia-gold bg-renuvia-gold bg-opacity-5'
                : 'border-gray-300 hover:border-renuvia-gold hover:bg-gray-50'
            }`}
            whileHover={{ scale: 1.01 }}
            whileTap={{ scale: 0.99 }}
          >
            <input
              type="radio"
              name={id}
              value={option.value}
              checked={value === option.value}
              onChange={(e) => onChange(e.target.value)}
              className="w-5 h-5 text-renuvia-gold focus:ring-renuvia-gold"
            />
            <span className="ml-3 text-lg text-charcoal">{option.label}</span>
          </motion.label>
        ))}
      </div>
      {error && <p className="text-red-500 text-sm mt-2">{error}</p>}
    </div>
  );
}
